import React from "react";
import { Box, Typography } from "@mui/material";

function getTone(state) {
  if (state === "active") {
    return {
      stroke: "#63d09c",
      track: "rgba(255,255,255,0.12)",
      inner: "rgba(8, 17, 31, 0.58)",
      text: "#f8fbff",
      subtext: "rgba(248,251,255,0.76)",
    };
  }
  if (state === "drift") {
    return {
      stroke: "#f3a43f",
      track: "rgba(255,255,255,0.11)",
      inner: "rgba(34, 22, 14, 0.48)",
      text: "#fff7ef",
      subtext: "rgba(255,247,239,0.76)",
    };
  }
  if (state === "reentry") {
    return {
      stroke: "#77ccb0",
      track: "rgba(255,255,255,0.11)",
      inner: "rgba(12, 29, 24, 0.46)",
      text: "#f5fffb",
      subtext: "rgba(245,255,251,0.74)",
    };
  }
  return {
    stroke: "#9fb2c8",
    track: "rgba(255,255,255,0.1)",
    inner: "rgba(10, 20, 37, 0.44)",
    text: "#edf5ff",
    subtext: "rgba(237,245,255,0.74)",
  };
}

export default function SprintMomentumRing({
  activeDaysLast7,
  todayActive,
  state,
  valueLabel = "",
  labelLineOne = "of 7 days",
  labelLineTwo = "active",
}) {
  const size = 146;
  const strokeWidth = 10;
  const radius = (size - strokeWidth) / 2;
  const circumference = 2 * Math.PI * radius;
  const progress = Math.max(0, Math.min(1, activeDaysLast7 / 7));
  const offset = circumference * (1 - progress);
  const tone = getTone(state);

  return (
    <Box sx={{ position: "relative", width: size, height: size, flexShrink: 0 }}>
      <svg width={size} height={size} aria-hidden="true">
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          stroke={tone.track}
          strokeWidth={strokeWidth}
          fill="none"
        />
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          stroke={tone.stroke}
          strokeWidth={strokeWidth}
          fill="none"
          strokeLinecap="round"
          strokeDasharray={`${circumference} ${circumference}`}
          strokeDashoffset={offset}
          transform={`rotate(-90 ${size / 2} ${size / 2})`}
        />
      </svg>

      <Box
        sx={{
          position: "absolute",
          inset: 18,
          borderRadius: "50%",
          backgroundColor: tone.inner,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
          textAlign: "center",
          gap: 0.15,
        }}
      >
        <Typography sx={{ fontSize: "2rem", lineHeight: 1, fontWeight: 800, letterSpacing: -1.4, color: tone.text }}>
          {valueLabel || activeDaysLast7}
        </Typography>
        <Typography sx={{ fontSize: "0.78rem", lineHeight: 1.25, fontWeight: 700, color: tone.subtext }}>
          {labelLineOne}
        </Typography>
        <Typography sx={{ fontSize: "0.74rem", lineHeight: 1.2, fontWeight: 700, color: tone.subtext }}>
          {labelLineTwo}
        </Typography>
        {todayActive ? (
          <Box sx={{ mt: 0.5, width: 7, height: 7, borderRadius: "50%", bgcolor: tone.text }} />
        ) : null}
      </Box>
    </Box>
  );
}
